import React from "react";
import "./commonServices.css";
import BlockChain from "../../Loading/BlockChain";

const BlockChainDevelopment = () => {
  return (
    <div className="it_services alternate">
      <div className="it_left">
        <BlockChain />
      </div>
      <div className="it_right">
        <span className="service-category">Web3 & Crypto</span>
        <h2>Next-Gen Blockchain Ecosytems</h2>
        <p>
          We pioneer decentralized solutions that redefine transparency and
          security. From bespoke smart contracts to full-scale NFT marketplaces,
          our expertise empowers your brand to lead the Web3 revolution with
          confidence and technical precision.
        </p>
        <div className="data_it">
          <p>Secure Smart Contracts</p>
          <p>DeFi Protocol Design</p>
          <p>Tokenomics Engineering</p>
          <p>NFT Core Architecture</p>
          <p>DEX & Wallet Dev</p>
          <p>Cross-Chain Bridges</p>
        </div>
      </div>
    </div>
  );
};

export default BlockChainDevelopment;
